export const baseUrl =
  "https://memberportal-dev.maxicare.com.ph/member-portal/api/v1";

export const forgerockErrors = {
  "ERR-001":
    "Mobile number or email address is already linked to another account. Please choose a different one.",
  "ERR-002": "We couldn't create your user account. Please try again.",
  "ERR-003": "This account is not active. Please activate your new Maxicare card.",
  "ERR-004": "Max OTP retry limit is reached",
  "ERR-005": "Max OTP resend limit is reached",
  "ERR-006": "Looks like a new number. Sign up to create an account!",
  "ERR-007": "Your email address isn't verified.",
  "ERR-008": "We ran into an issue registering your device. Please try again.", //error in push registration
  "ERR-009": "Your mobile number isn't verified.",
  "ERR-010": "Some required information is missing. Please try again.",
  "ERR-011": "Person ID validation failed",
  "ERR-012": "Your session has expired. Please log in again.",
  "ERR-013": "Your account is locked. Please contact support.",
  "ERR-014": "We couldn't retrieve your account information. Please try again.", //get member info api error
  "ERR-015": "Login failed. You’re not authorized to access this account.",
  "ERR-016":
    "The email or mobile number you entered is invalid. Please check and try again.",
  "ERR-017": "Something went wrong on our end. Please try again later.",
  "ERR-018":
    "We encountered an issue during registration. Please try again later.",
  "ERR-019":
    "We ran into an issue adding your membership card. Please try again.",
  "ERR-020":
    "There was an issue adding your dependent's card. Please try again.",
  "ERR-021": "We ran into an issue verifying your OTP. Please try again.",
  "ERR-022": "We couldn't add your membership card. Please try again.",
  "ERR-023": "We couldn't add your family member's card. Please try again.",
  "ERR-024": "We encountered an issue sending the email OTP. Please try again.",
  "ERR-025": "We encountered an issue sending the SMS OTP. Please try again.",
  "ERR-026": "We encountered an issue while updating eKYC details.",
  "ERR-027": "We couldn't update your email address. Please try again.",
  "ERR-028": "We couldn't update your mobile number. Please try again.",
  "ERR-029": "User with the same PersonID already exists.",
  "ERR-030":
    "Mobile number already linked to another account. Please choose a different one",
  "ERR-031":
    "Email address already linked to another account. Please choose a different one",
  "ERR-032": "We couldn't verify your email. Please try again.",
  "ERR-033":
    "Your email verification code has expired. Please request a new one.",
  "ERR-034": "Option is not valid",
  "ERR-035": "Something went wrong on our end. Please try again later.",
  SWW: "Something went wrong.",
};
